import { axiosV2 } from "config/@axios";
import i18next from "i18next";

import * as uiActions from "store/actions/uiActions";
import * as authActions from "store/actions/authActions";

export const SAVE_SIGNATURE = "signatureActions::saveSignature";
export const SAVE_SIGNATURE_SUCCESS = "signatureActions::saveSignatureSuccess";
export const SAVE_SIGNATURE_FAILED = "signatureActions::saveSignatureFailed";
export const SET_CURRENT_ITEM = "signatureActions::setCurrentItem";
export const RESET_FAILED = "signatureActions::resetFailed";

const handleSignatureSuccess = (dispatch, fn, signatures) => {
  if (typeof fn === "function") {
    fn();
  }

  dispatch({ type: SAVE_SIGNATURE_SUCCESS });

  dispatch(
    authActions.updateSettings({
      signature: signatures
    })
  );

  dispatch(
    uiActions.addSnackbar({
      message: i18next.t("settings:signs.success_message")
    })
  );
};

const handleSignatureError = (dispatch, err) => {
  dispatch({
    type: SAVE_SIGNATURE_FAILED,
    payload: {
      errorMessage: err?.errorMessage
    }
  });
};

export const addSignature =
  (obj, fn = () => {}) =>
  async dispatch => {
    dispatch({ type: SAVE_SIGNATURE });

    try {
      const body = {
        id: obj.id,
        title: obj.title,
        content: obj.content,
        for_new_emails: obj.for_new_emails,
        reply_forward: obj.reply_forward
      };

      const response = await axiosV2.post("settings/signature", body);
      const signatures = Array.isArray(response.data) ? response.data : [];

      handleSignatureSuccess(dispatch, fn, signatures);

      const current =
        signatures.find(item => item.id === obj.id) || signatures[0] || null;

      dispatch(setCurrentItem(current));
    } catch (err) {
      handleSignatureError(dispatch, err);
    }
  };

export const deleteSignature = obj => async (dispatch, getState) => {
  dispatch({ type: SAVE_SIGNATURE });

  const state = getState();
  const currentSignatures = state.auth?.settings?.signature || [];
  const filteredSignatures = currentSignatures.filter(
    item => item.id !== obj.id
  );

  try {
    const response = await axiosV2.delete(`settings/signature/${obj.id}`);
    const responseSignatures = Array.isArray(response.data)
      ? response.data
      : [];

    const signatures =
      responseSignatures.length > 0 ? responseSignatures : filteredSignatures;

    handleSignatureSuccess(dispatch, undefined, signatures);

    dispatch(setCurrentItem(null));
  } catch (err) {
    handleSignatureError(dispatch, err);
  }
};

export const editSignature =
  (obj, fn = () => {}) =>
  async dispatch => {
    dispatch({ type: SAVE_SIGNATURE });

    try {
      const body = {
        title: obj.title,
        content: obj.content,
        for_new_emails: obj.for_new_emails,
        reply_forward: obj.reply_forward
      };

      const response = await axiosV2.put(`settings/signature/${obj.id}`, body);
      const signatures = Array.isArray(response.data) ? response.data : [];

      handleSignatureSuccess(dispatch, fn, signatures);

      const current = signatures.find(item => item.id === obj.id) || null;

      dispatch(setCurrentItem(current));
    } catch (err) {
      handleSignatureError(dispatch, err);
    }
  };

export const legacySetDefaultSignature = (key, obj) => (dispatch, getState) => {
  // setDefaultSignature kullanımında eksikler ve backend ihtiyacından kaynkalı şimdilik legacy olarak devam edildi ilerde düzenlenmeli
  const state = getState();
  const signArr = state.auth.settings.signature;

  const index = signArr.findIndex(item => item.id === obj.id);
  const arr = signArr.map(item => ({ ...item, [key]: "no" }));
  arr[index] = obj;
  const payload = {
    signature: [...arr]
  };
  dispatch({ type: SAVE_SIGNATURE });
  return axiosV2
    .put("settings", payload)
    .then(() => {
      handleSignatureSuccess(dispatch, undefined, payload.signature);
      const current =
        payload.signature.find(item => item.id === obj.id) || null;

      dispatch(setCurrentItem(current));
    })
    .catch(err => {
      handleSignatureError(dispatch, err);
    });
};

export const setDefaultSignature = (key, obj) => async dispatch => {
  dispatch({ type: SAVE_SIGNATURE });

  try {
    const body = {
      title: obj.title,
      content: obj.content,
      for_new_emails: key === "for_new_emails" ? "yes" : obj.for_new_emails,
      reply_forward: key === "reply_forward" ? "yes" : obj.reply_forward
    };

    const response = await axiosV2.put(`settings/signature/${obj.id}`, body);
    const signatures = Array.isArray(response.data) ? response.data : [];

    handleSignatureSuccess(dispatch, undefined, signatures);

    const current = signatures.find(item => item.id === obj.id) || null;

    dispatch(setCurrentItem(current));
  } catch (err) {
    handleSignatureError(dispatch, err);
  }
};

export const setCurrentItem = item => {
  return {
    type: SET_CURRENT_ITEM,
    payload: { item }
  };
};

export const resetFailed = () => ({
  type: RESET_FAILED
});
